module.exports = __webpack_public_path__ + "static/media/nav1.b965d931.png";